import { ReactNode } from "react";

import { SVG_MUI } from "@ryde/assets";
import { DirectionEnum } from "@ryde/shared";

export const isCheckboxClick = (target: EventTarget): boolean =>
  Boolean((target as HTMLElement).closest?.(".rc-chip__select"));

export const renderDirectionIcon = (
  direction: DirectionEnum | undefined,
  e2eId: number,
): ReactNode => {
  const dataE2e = `rides-calendar-direction-${e2eId}`;
  if (direction === DirectionEnum.PickUp) {
    return <SVG_MUI.OvalTo2SVG data-e2e={dataE2e} />;
  }
  if (direction === DirectionEnum.DropOff) {
    return <SVG_MUI.OvalBack2SVG data-e2e={dataE2e} />;
  }
  return <SVG_MUI.OvalNone2SVG data-e2e={dataE2e} />;
};

export const directionTooltipKey = (
  direction: DirectionEnum | undefined,
): string => {
  if (direction === DirectionEnum.PickUp) {
    return "selectListLabel.DirectionA";
  }
  if (direction === DirectionEnum.DropOff) {
    return "selectListLabel.DirectionB";
  }
  return "selectListLabel.DirectionAB";
};
